<div class="floating-chat-container" [class.open]="isChatOpen">
  <div class="chat-header">
    <div class="title-section">
      <span class="title">Trace Fornecedores</span>
      <span class="subtitle">Assistente de análise</span>
    </div>

    <div class="header-actions">
      <button mat-icon-button type="button" (click)="clearChat()" title="Limpar conversa">
        <fa-icon [icon]="faTrash"></fa-icon>
      </button>
      <button mat-icon-button type="button" (click)="closeChat()" title="Fechar chat">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="chat-body">
    <div class="messages-list">
      <div
        *ngFor="let message of messages"
        class="message-row"
        [ngClass]="{ 'user-message': message.sender === 'user', 'ai-message': message.sender === 'ai' }"
      >
        <div class="message-bubble">
          <div class="message-text">{{ message.text }}</div>

          <div *ngIf="message.actionButton" class="message-action-button">
            <button mat-raised-button color="primary" type="button" (click)="handleMessageAction(message.actionButton.route)">
              {{ message.actionButton.label }}
            </button>
          </div>

          <div class="message-time">{{ message.time }}</div>
        </div>
      </div>

      <div *ngIf="messages.length === 1 && messages[0].sender === 'ai'" class="suggested-actions">
        <button mat-stroked-button type="button" *ngFor="let action of suggestedActions" (click)="handleSuggestedAction(action)">
          {{ action }}
        </button>
      </div>
    </div>
  </div>

  <div class="chat-input-area">
    <mat-form-field appearance="outline" class="full-width-input">
      <input
        matInput
        placeholder="Digite sua mensagem..."
        [(ngModel)]="newMessage"
        (keyup.enter)="sendMessage()"
      />
      <button mat-icon-button matSuffix color="primary" type="button" (click)="sendMessage()" [disabled]="!newMessage.trim()">
        <mat-icon>send</mat-icon>
      </button>
    </mat-form-field>
  </div>
</div>
